// shared/hooks/useGetPublicProfile.js
import { useCallback, useEffect, useState } from 'react';
import { fetchPublicProfile } from '../data/fetchPublicProfile';

const useGetPublicProfile = (token) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!token) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const payload = await fetchPublicProfile(token);
      setData(payload);
    } catch (err) {
      console.error('useGetPublicProfile:', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, refetch: load };
};

export default useGetPublicProfile;
